package com.iregained.eventapp.components.models

import kotlinx.serialization.Serializable

@Serializable
data class OperatingDayData(
    val date: String = "2026-09-15",
    val startTime: String = "08:30",
    val endTime: String = "16:00",
    val isClosed: Boolean = false
)